import React, { useEffect, useMemo, useState } from "react"
import { DateTime } from "luxon"
import { navigate } from "react-big-calendar/lib/utils/constants"

function createCalendar(currentDate) {
  const current =
    currentDate ? DateTime.fromJSDate(currentDate) : DateTime.local()
  const first = current.startOf("month")
  const last = current.endOf("month")
  const daysInMonth = last.day
  const firstWeekday = first.weekday % 7
  const weeksCount = 6

  const calendar = Object.assign([], { currentDate: current, first, last })

  for (let weekNumber = 0; weekNumber < weeksCount; weekNumber++) {
    const week = []
    calendar.push(week)
    calendar.year = current.year
    calendar.month = current.month

    for (let day = 0; day < 7; day++) {
      const offset = weekNumber * 7 + day - firstWeekday
      const date = first.plus({ days: offset })
      date.calendar = calendar
      week.push(date)
    }
  }

  return calendar
}

function CalendarDate({ dateToRender, dateOfMonth, onClick }) {
  const today =
    dateToRender.toISODate() === DateTime.local().toISODate() ? "today" : ""

  if (dateToRender.month < dateOfMonth.month) {
    return (
      <button disabled className="date prev-month">
        {dateToRender.day}
      </button>
    )
  }

  if (dateToRender.month > dateOfMonth.month) {
    return (
      <button disabled className="date next-month">
        {dateToRender.day}
      </button>
    )
  }

  return (
    <button
      className={`date in-month ${today}`}
      onClick={() => onClick(dateToRender)}
    >
      {dateToRender.day}
    </button>
  )
}

function Calendar({ date }) {
  const [calendar, setCalendar] = useState(undefined)

  useEffect(() => {
    setCalendar(createCalendar(date))
  }, [date])

  if (!calendar) return null

  return (
    <div className="month">
      <div className="month-name">
        {calendar.currentDate.setLocale("es").toFormat("MMMM")}
      </div>
      {["D", "L", "M", "X", "J", "V", "S"].map((day, index) => (
        <span key={index} className="day">
          {day}
        </span>
      ))}
      {calendar.map((week, index) => (
        <div key={index}>
          {week.map((date) => (
            <CalendarDate
              key={date.toISODate()}
              dateToRender={date}
              dateOfMonth={calendar.currentDate}
              onClick={(date) =>
                alert(`Dia clickeado en yearview ${date.toISODate()}`)
              }
            />
          ))}
        </div>
      ))}
    </div>
  )
}

function YearView({ date }) {
  const firstMonth = useMemo(
    () => DateTime.fromJSDate(date).startOf("year"),
    [date]
  )

  const months = useMemo(() => {
    return Array.from({ length: 12 }, (_, i) => {
      const monthDate = firstMonth.plus({ months: i }).toJSDate()
      return <Calendar key={i} date={monthDate} />
    })
  }, [firstMonth])

  return <div className="year">{months}</div>
}

YearView.range = (date) => {
  return [DateTime.fromJSDate(date).startOf("year").toJSDate()]
}

YearView.navigate = (date, action) => {
  const dt = DateTime.fromJSDate(date)
  switch (action) {
    case navigate.PREVIOUS:
      return dt.minus({ years: 1 }).toJSDate()
    case navigate.NEXT:
      return dt.plus({ years: 1 }).toJSDate()
    default:
      return date
  }
}

YearView.title = (date, { localizer }) =>
  DateTime.fromJSDate(date).toFormat("yyyy")

export default YearView
